/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{parseUrl as r}from"../utils.js";import{executeQueryForCount as o}from"./operations/query.js";import t from"../support/Query.js";function m(m,p,i,s){return o(r(m),t.from(p),i,s)}export{m as executeForCount};
